import { httpClient } from "../httpClient";

interface ValidateResponse {}

class ValidateService {
  async validate(code: string, targetId: string, imageBase64: string) {
    const { data } = await httpClient.post<ValidateResponse>(
      "proxy/validate-unico",
      {
        code,
        targetId,
        imageBase64,
      }
    );
    return data;
  }
}
export default new ValidateService();
